import getFunctionData from "../../../../utils/get-function-data";

/**
 * Get trigger name from the string
 * @param {String} input
 * @returns {Map<"name" |"parameters", any>}
 */
const getTriggerName = (input = "") => {
  const data = getFunctionData(input);

  return new Map([
    ["name", data.get("name")],
    ["parameters", data.get("parameters")],
  ]);
};

export default getTriggerName;
